import { FETCH_PRICE_START, FETCH_PRICE_END } from '../actions';

export default function (state={}, action){
  switch (action.type) {
    case FETCH_PRICE_START:
      return {
        ...state,
        loading:true
    };
    case FETCH_PRICE_END:
      return {
        ...state,
        loading:false,
        regionPrice:action.payload
    };
    default:
      return state;

  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/reducer_region.js